"use strict"
import {tutils, PropTypes, resolvers} from "Subschema";

const {noop, resolveKey} = tutils;

function fixKey(key) {
    const ret = key.replace(/\$/g, '.');
    return ret;
}
export function prefill(path, key, props, {valueManager}) {
    if (!path) {
        return noop;
    }
    //allow for
    if (typeof path === 'object') {
        const context = {valueManager};
        const removes = Object.keys(path).map((value)=>this::prefill(path[value], key, {...props, value: fixKey(value)}, context));
        return function prefill$remove() {

            for (let r of removes) {
                r && r();
            }
        }
    }
    const valuePath = resolveKey(props.path, props.value);
    var self = this;
    const remove = valueManager.addListener(path, (val)=> {
        const oVal = valueManager.path(valuePath);
        const noValue = oVal == null;
        if (noValue) {
            const prefillValue = valueManager.path(path);
            if (prefillValue != null) {
                if (typeof prefillValue === 'object') {
                    Object.keys(prefillValue).forEach(function (k) {
                        valueManager.update(`${valuePath}.${k}`, prefillValue[k]);
                    });
                } else {
                    valueManager.update(valuePath, prefillValue);

                }
                remove && remove();
            }
        } else {
            remove && remove();
        }
    }, null, true).remove;
    return remove;
}

export default function prefill$resolver(Clazz, key) {

    Clazz.contextTypes.valueManager = PropTypes.valueManager;

    Clazz::this.listener(key, prefill);
}


/** WEBPACK FOOTER **
 ** ./src/resolver/prefill.js
 **/